/**
 * Global touch-point ripple for Android .press-scale elements.
 *
 * Instead of the static ::after opacity overlay, this creates a radial ripple
 * expanding from the actual touch point — matching Material 3 behavior.
 *
 * Called once from initCapacitor(). Attaches a single document-level listener.
 */

const SCROLL_THRESHOLD = 10;

let activeRipple = null;

function createRipple(el, e) {
  const rect = el.getBoundingClientRect();
  const x = e.clientX - rect.left;
  const y = e.clientY - rect.top;
  const size = Math.max(rect.width, rect.height) * 2;

  const span = document.createElement('span');
  span.className = 'ripple-circle';
  span.style.left = `${x - size / 2}px`;
  span.style.top = `${y - size / 2}px`;
  span.style.width = `${size}px`;
  span.style.height = `${size}px`;

  el.appendChild(span);

  return {
    span,
    el,
    startX: e.clientX,
    startY: e.clientY,
  };
}

function removeRipple(fade) {
  if (!activeRipple) return;
  const { span } = activeRipple;
  activeRipple = null;

  if (fade) {
    span.classList.add('ripple-fade-out');
    span.addEventListener('animationend', () => span.remove(), { once: true });
  } else {
    span.remove();
  }
}

function onPointerDown(e) {
  const el = e.target.closest('.press-scale');
  if (!el) return;

  removeRipple(false);
  activeRipple = createRipple(el, e);
}

function onPointerMove(e) {
  if (!activeRipple) return;
  const dx = e.clientX - activeRipple.startX;
  const dy = e.clientY - activeRipple.startY;
  if (dx * dx + dy * dy > SCROLL_THRESHOLD * SCROLL_THRESHOLD) {
    removeRipple(false);
  }
}

function onPointerEnd() {
  removeRipple(true);
}

export default function initAndroidRipple() {
  document.addEventListener('pointerdown', onPointerDown, { passive: true });
  document.addEventListener('pointermove', onPointerMove, { passive: true });
  document.addEventListener('pointerup', onPointerEnd, { passive: true });
  document.addEventListener('pointercancel', onPointerEnd, { passive: true });
}
